﻿
import {
    trigger,
    style,
    animate,
    transition,
    state,
    keyframes,
    group
} from '@angular/animations';

// nav menu
const navWidth = '12em';
const navAnimationDuration = 250;

export const navAnimatedHeader = trigger('navAnimatedHeader', [
    state('out, void', style({
        left: 0
    })),
    state('in', style({
        left: navWidth
    })),
    transition('out => in', [
        animate(navAnimationDuration)
    ])
]);

export const navAnimatedMenu = trigger('navAnimatedMenu', [
    state('out, void', style({
        opacity: 0,
        transform: 'translateX(-100%)',
        width: navWidth
    })),
    state('in', style({
        opacity: 1,
        transform: 'translateX(0)',
        width: navWidth
    })),
    transition('out => in', [
        animate(navAnimationDuration)
    ])
]);
